const POST_LOGIN_RETURN_TO_KEY = "OZK_POST_LOGIN_RETURN_TO";
const AUTH_ONLY_PATHS = new Set([
  "/login",
  "/auth/kakao/callback",
  "/nickname/setup",
]);

export function getSafeReturnTo(
  candidate: string | null | undefined,
  fallback = "/",
): string {
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return fallback;
  }

  const path = candidate.split(/[?#]/, 1)[0];
  return AUTH_ONLY_PATHS.has(path) ? fallback : candidate;
}

export function rememberPostLoginPath(candidate?: string): void {
  const current =
    candidate || `${window.location.pathname}${window.location.search}`;
  const safePath = getSafeReturnTo(current, "");
  if (safePath && safePath !== "/") {
    sessionStorage.setItem(POST_LOGIN_RETURN_TO_KEY, safePath);
  }
}

export function buildLoginPath(candidate?: string): string {
  const current =
    candidate || `${window.location.pathname}${window.location.search}`;
  const safePath = getSafeReturnTo(current, "/");
  return `/login?returnTo=${encodeURIComponent(safePath)}`;
}

export function consumePostLoginPath(): string {
  const stored = sessionStorage.getItem(POST_LOGIN_RETURN_TO_KEY);
  sessionStorage.removeItem(POST_LOGIN_RETURN_TO_KEY);
  return getSafeReturnTo(stored, "/");
}
